(function () {
  const MOBILE_BREAKPOINT = 749;

  const getSettings = () => ({
    slidesPerView: 1.3,
    spaceBetween: 12,
    speed: 800,
    watchSlidesProgress: true,
    allowTouchMove: true,
    mousewheel: {
      forceToAxis: true,
    },
  });

  const initSlider = (sliderEl) => {
    const slides = sliderEl.querySelectorAll(".instagram__item");
    if (!slides.length) return;

    const isMobile = window.matchMedia(
      `(max-width: ${MOBILE_BREAKPOINT}px)`
    ).matches;

    if (!isMobile) {
      if (sliderEl.swiper) sliderEl.swiper.destroy(true, true);
      return;
    }

    if (sliderEl.swiper) return;
    if (typeof Swiper === "undefined") return;

    new Swiper(sliderEl, getSettings());
  };

  const initAll = (root) => {
    root
      .querySelectorAll(".js-instagram-mobile-slider")
      .forEach((el) => initSlider(el));
  };

  const run = () => initAll(document);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(run, 150);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
